import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VesselSaveButtonComponent } from './vessel-save-button.component';
import { AsyncButtonModule } from '../../../../../shared/directives/async-button/async-button.module';
import { MatButtonModule } from '@angular/material/button';

@NgModule({
  declarations: [VesselSaveButtonComponent],
  exports: [VesselSaveButtonComponent],
  imports: [CommonModule, AsyncButtonModule, MatButtonModule],
})
export class VesselSaveButtonModule {}
